module.exports = __webpack_public_path__ + "img/ChampmandiInkBlack.b5f7bf14.png";